import { useEffect, type PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import { CinemaHeader, CinemaFooter } from "./CinemaChrome";

export const LayoutComponent = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      requestAnimationFrame(() => document.getElementById(location.hash.slice(1))?.scrollIntoView());
    } else window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);
  if (["/dashboard", "/", "/this-is-me"].includes(location.pathname.replace(/\/$/, "") || "/")) return <>{children}</>;
  return <div className="cinema-home cinema-interior">
    <a className="cinema-skip" href="#page-main">Skip to content</a>
    <CinemaHeader />
    <main id="page-main" className="cinema-page-content">{children}</main>
    <CinemaFooter />
  </div>;
};
